export default __webpack_public_path__ + "static/media/accelerons.34784bcf.webp";